// Generated from DisplayNameGenerator.php
import type { BlockStateType } from "@/model/backend/block-state-type"
import type { PayType } from "@/model/backend/pay-type"

export function $blockStateType(type: BlockStateType): string {
    return {
        "None": "Keine",
        "NewCustomer": "Neukunde",
        "Inactive": "Inaktiv",
        "InactivePermanent": "Dauerhaft inaktiv",
        "Manual": "Sonstige",
        "PendingDeletion": "L\u00f6schung ausstehend"
    }[type] ?? ''
}

export function $payType(type: PayType | string): string {
    return ({
        "self": "Selbstzahler",
        "private_insurance": "Privatversichert",
        "public_insurance": "Kassenpatient",
        "public_free": "Kassenpatient (Zuzahlungsbefreit)",
        "doctor": "Arzt",
        "berufsgenossenschaft": "Berufsgenossenschaft",
        "Self": "Selbstzahler",
        "PrivateInsurance": "Privatversichert",
        "PublicInsurance": "Kassenpatient",
        "PublicFree": "Kassenpatient (Zuzahlungsbefreit)",
        "Doctor": "Arzt",
        "Berufsgenossenschaft": "Berufsgenossenschaft"
    } as Record<string, string>)[type] ?? ''
}

export function $gender(gender: string, defaultValue: string = ''): string {
    const genders: Record<string, string> = {
        "m": "m\u00e4nnlich",
        "f": "weiblich",
        "d": "divers"
    };
    
    if (gender === null || gender === undefined) {
        return "nicht gewählt"
    }
    
    return genders[gender] ?? defaultValue
}

export function $shippingMethod(method: string | undefined): string {
    return {
        "pickup": "Pick-Up",
        "dhl_express": "DHL-Express",
        "go": "GO!-Express",
        "dhl_package": "DHL-Paket",
        "pickup_service": "Abholung selber beauftragen",
        "carrier": "Lieferung durch Apothekenbote"
    }[method ?? ''] ?? '-'
}

export function $paymentMethod(method: string | undefined): string {
    return {
        "bankTransfer": "\u00dcberweisung",
        "offline": "Bar oder Karte",
        "postPayment": "Rechnung"
    }[method ?? ''] ?? '-'
}

export function $articleUnit(unit: string | null | undefined): string {
    return ({
        "g": "Gramm",
        "mg": "Milligramm",
        "ml": "Milliliter",
        "stk": "St\u00fcck"
    } as Record<string, string>)[unit ?? ''] ?? 'Einheit'
}
